import React, { useCallback, useEffect, useState } from 'react';

import { LINK_ONBOARDING } from 'config';
import getShouldShowOnboardingFromParams from 'src/api/getShouldShowOnboardingFromParams';
import Modal from 'src/app/components/Modal/Modal';
import icon from 'src/images/onboarding-teaser-icon.svg';

import 'src/app/components/OnboardingTeaser/OnboardingTeaser.scss';


const { header, description, buttonTxt } = {
  header: 'Dokończ proces.',
  description: 'Odpowiedz na kilka pytań a dopasujesz oferty, które widzisz, do pracy której szukasz.',
  buttonTxt: 'Dopasuj oferty'
};

const OnboardingTeaser = () => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [shouldShowOnboarding, setShouldShowOnboarding] = useState(false);

  const handleModalClose = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  useEffect(() => {
    setShouldShowOnboarding(() => getShouldShowOnboardingFromParams(window.location.search));
  }, []);

  return shouldShowOnboarding && isModalVisible ? (
    <div styleName="onboarding-teaser">
      <Modal
        header={ header }
        headerIcon={ icon }
        onClose={ handleModalClose }
      >
        <p styleName="onboarding-teaser__desc">{description}</p>
        <div styleName="onboarding-teaser__button-wrapper">
          <a
            href={ LINK_ONBOARDING }
            styleName="onboarding-teaser__button"
          >
            {buttonTxt}
          </a>
        </div>
      </Modal>
    </div>
  ) : null;
};

export default OnboardingTeaser;
